//'use strict';
export default class SectionPageController {

    constructor() {
        let vm = this;
        vm.pageTitle = 'Section Page View';

        vm.reportLinkSelected=(report)=>{
            ga('send', {
                hitType: 'event',
                eventCategory: 'VisApps',
                eventLabel: 'visapp-top-global-hair-care',
                eventAction: 'visapp-top-global-hair-care-report-clicked-' + report
            });


            ga('send', {
                hitType: 'screenview',
                appName: 'visapp-top-global-hair-care',
                screenName: 'visapp-top-global-hair-care-report-clicked-' + report
            });

        }

    }
}
SectionPageController.$inject = [];



// WEBPACK FOOTER //
// ./src/app/views/section-page/section-page.controller.js